import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { SiteConfigProvider } from "./context/SiteConfigContext";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/toaster";

const STATIC_MODE = process.env.REACT_APP_STATIC_MODE === 'true';

// Lazily require Admin only in dynamic mode to keep static build minimal
let Admin = null;
if (!STATIC_MODE) {
  // eslint-disable-next-line global-require
  Admin = require('./pages/Admin').default;
}

function App() {
  return (
    <div className="App">
      <SiteConfigProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              {Admin && <Route path="/admin" element={<Admin />} />}
            </Routes>
            <Toaster />
          </BrowserRouter>
        </LanguageProvider>
      </SiteConfigProvider>
    </div>
  );
}

export default App;
